class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this._swiper = null;
    this.hasCustomOptions = this.hasAttribute("data-overwrite-options");
  }

  get slidesPerViewMobile() {
    return this.dataset.slidesPerViewMobile ? Number(this.dataset.slidesPerViewMobile) : 2;
  }
  get slidesPerViewTablet() {
    return this.dataset.slidesPerViewTablet ? Number(this.dataset.slidesPerViewTablet) : 3;
  }
  get slidesPerViewDesktop() {
    return this.dataset.slidesPerViewDesktop ? Number(this.dataset.slidesPerViewDesktop) : 4;
  }

  buildDefaultOptions() {
    return {
    "slidesPerView": this.slidesPerViewMobile,
    "slidesPerGroup": 1,
    "spaceBetween": 20,
    "grabCursor": true,
    "pauseOnMouseEnter": true,
    "freeMode": { "enabled": true, "sticky": true },
    "mousewheel": {
      "forceToAxis": true
    },
    "breakpoints": {
      "750": {
        "slidesPerView": this.slidesPerViewTablet
      },
      "1000": {
          "slidesPerView": this.slidesPerViewDesktop,
          "spaceBetween": 30
        }
    },
    "scrollbar": {
      "el": ".highlighted-section--scrollbar-" + this.slider?.id,
      "draggable": true,
      "dragSize": "auto"
    }
  };
  }

  getOverwriteOptions() {
    try {
      const raw = this.dataset.overwriteOptions;
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      console.warn("Invalid Swiper config, falling back to defaults:", e);
      return null;
    }
  }

  connectedCallback() {
    this.initSlider();
  }

  disconnectedCallback() {
    if (this._swiper) {
      this._swiper.destroy();
      this._swiper = null;
    }
  }

  initSlider() {
    // @ts-ignore
    if (typeof Swiper === "undefined") return;

    this.slider = this.querySelector(".swiper");
    if (!this.slider) return;
    const options = this.hasCustomOptions ? this.getOverwriteOptions() || this.buildDefaultOptions() : this.buildDefaultOptions();
    // @ts-ignore
    this._swiper = new Swiper(this.slider, options);
  }
}

if (!customElements.get("swiper-slider")) {
  customElements.define("swiper-slider", SwiperSlider);
}
